import React, { useCallback, useEffect, useState } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import qs from "query-string";
import Axios from "axios";
import classNames from "classnames";
import { useEffectOnce } from "react-use";
import Select, { Option } from "rc-select";
import ReactLoading from "react-loading";
import { useRef } from "react";

// function deep(source) {
//   let isArray = !!~Object.prototype.toString.call(source).indexOf("Array");
//   let target = isArray ? [] : {};
//   for (let key in source) {
//     const itemIsObject = !!~Object.prototype.toString
//       .call(source[key])
//       .indexOf("Object");
//     const itemIsArray = !!~Object.prototype.toString
//       .call(source[key])
//       .indexOf("Array");
//     if (itemIsObject || itemIsArray) {
//       target[key] = itemIsObject ? {} : [];
//       target[key] = deep(source[key]);
//     } else {
//       target[key] = source[key];
//     }
//   }
//   return target;
// }

// export const useDebounce = (fn, delay) => {
//   const { current } = useRef({ time: 0 });
//   return useCallback(
//     (...args) => {
//       if (current.time) {
//         clearTimeout(current.time);
//         current.time = null;
//       }
//       current.time = setTimeout(() => {
//         fn.apply(this, args);
//         current.time = null;
//       }, delay);
//     },
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//     [current, delay]
//   );
// };

export const MarketplaceType = (props) => {
  const { id } = useParams();
  const { t, i18n } = useTranslation();
  const { list, setList, setLoading } = props;
  const [typeLoading, setTypeLoading] = useState(false);
  const [currentType, setCurrentType] = useState("");
  const [categories, setCategories] = useState([]);
  const [page, setPage] = useState(1);
  const [maxnum, setMaxnum] = useState(42);
  const isWindow = () => typeof window !== "undefined";
  const isDocument = () => typeof document !== "undefined";
  const [fixedSider, setfixedSider] = useState(false);
  const esignApp = {
    logo: "//files.authing.co/authing-website/marketplace-icon-eqianbao.png",
    nameI18n: {
      "en-US": "eSign",
      "zh-CN": "e签宝",
    },
    descriptionI18n: {
      "en-US":
        "eSign is a leader in China's Internet electronic signature industry. It is committed to providing customers with legally effective electronic contract full life cycle services, reducing the document signing process that would otherwise take several days to just tens of seconds.",
      "zh-CN":
        "e签宝是中国互联网电子签名行业领跑者。致力于为客户提供具有法律效力的电子合同全生命周期服务，将原本需要耗费数日之久的文件签署环节，压缩到只需几十秒。",
    },
    identifier: "esign",
  };
  const getMarketplaceType = (category) => {
    setLoading(true);
    Axios.get(`/api/marketplace-list?category=${category}&page=1`)
      .then((res) => {
        const dataList = res?.data?.data || [];
        // if (category === "" || category === "co-office") {
        //   dataList.push(esignApp);
        // }
        setList(dataList);
        setLoading(false);
      })
      .catch((res) => {
        console.log("error" + res);
      });
  };
  // const getmore = useCallback(async () => {
  //   // setLoading(true);

  //   try {
  //     if (list?.length >= maxnum) return;
  //     setMoreloding(true);
  //     const response = await Axios.get(
  //       `/api/marketplace-list?category=${currentType}&page=${page}`
  //     );
  //     const dataList = response?.data?.data || [];
  //     const newList = [...deep(list), ...dataList];
  //     setList(newList);
  //     setMoreloding(false);
  //   } catch (err) {
  //     console.log(err);
  //     setMoreloding(false);
  //   }
  // }, [currentType, list, maxnum, page, setList, setMoreloding]);

  // const autoScroll = useCallback(() => {
  //   const scrollTop = document.documentElement.scrollTop;

  //   const clientHeight = document.documentElement.clientHeight;

  //   const blockOffsetTop =
  //     document.querySelector(".reference-block").offsetTop - scrollTop;

  //   if (blockOffsetTop < (clientHeight / 4) * 3) {
  //     setPage((page) => page + 1);
  //   }
  // }, []);

  // const debounce = useDebounce(() => {
  //   if (isDocument()) {
  //     autoScroll();
  //   }
  // }, 500);

  const scrollHandler = useCallback(() => {
    if (isDocument()) {
      const scrollTop = document.documentElement.scrollTop;

      const listBoxTop = document.querySelector(".application-box").offsetTop;

      const listBoxbottom =
        document.querySelector(".application-box").offsetHeight + listBoxTop;
      if (scrollTop >= listBoxTop - 100 && scrollTop < listBoxbottom - 400) {
        setfixedSider(true);
      } else {
        setfixedSider(false);
      }
    }
  }, []);

  // useEffect(() => {
  //   getmore();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [page]);

  // useEffect(() => {
  //   isWindow() && window.addEventListener("scroll", debounce);
  //   return () => {
  //     isWindow() && window.removeEventListener("scroll", debounce);
  //   };
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  useEffect(() => {
    isWindow() && window.addEventListener("scroll", scrollHandler);
    return () => {
      isWindow() && window.removeEventListener("scroll", scrollHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffectOnce(() => {
    setTypeLoading(true);
    Axios.get("/api/marketplace-category")
      .then((res) => {
        setCategories(res?.data?.data || []);
        setTypeLoading(false);
      })
      .catch((res) => {
        console.log("error" + res);
      });
  });

  const onChange = (e) => {
    let value;
    if (e && e.target) {
      ({ value } = e.target);
    } else {
      value = e;
    }
    setCurrentType(value);

    setPage(1);
    setList([]);
    getMarketplaceType(value);
  };
  const marketplaceTypeMbile = () => {
    return (
      <div className="marketplace-type-box-mobile">
        <Select
          value={currentType}
          onChange={onChange}
          placeholder="全部"
          className="select-style"
        >
          {categories?.map((item, index) => (
            <Option
              key={index}
              value={item.identifier ? item.identifier : ""}
              className="select-option"
            >
              <span className="label">{item.nameI18n[i18n.language]}</span>
              <span className="count">{item.count}</span>
            </Option>
          ))}
        </Select>
      </div>
    );
  };
  const marketplaceType = () => {
    return (
      <div className="marketplace-type-box">
        {typeLoading && (
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
              alignContent: "center",
              paddingTop: "40px",
            }}
          >
            <ReactLoading
              type="spinningBubbles"
              color="#396aff"
              height={30}
              width={30}
            />
          </div>
        )}
        {!typeLoading && (
          <div
            className={classNames({
              "marketplace-type": true,
              fixed: fixedSider,
            })}
          >
            {categories.map((item) => {
              const cls = classNames({
                "type-item": true,
                checked:
                  currentType === (item.identifier ? item.identifier : ""),
              });
              return (
                <div
                  className={cls}
                  onClick={() => {
                    setPage(1);
                    setList([]);
                    getMarketplaceType(item.identifier ? item.identifier : "");
                    setCurrentType(item.identifier ? item.identifier : "");
                    setMaxnum(item.count);
                    isWindow && window.scrollTo(0, 400);
                  }}
                >
                  <span className="label">{item.nameI18n[i18n.language]}</span>
                  <span className="count">{item.count}</span>
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      {marketplaceType()}
      {marketplaceTypeMbile()}
    </>
  );
};
